import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import mcposter from '../assets/mcposter.png'
import './Login.css'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import Cookies from 'js-cookie'
import { base_url_toonflix } from '../Services/api';



// mcfunny.madfunny.co.za
// https://madfunny.co.za/DoiRedirect?subscription_id=2123446562&msisdn=27680633950&ext_ref=testing_ref
const Login = ({ service_id, serviceName }) => {
  const [q] = useSearchParams();
  const [number, setNumber] = useState('');
  const [loading, setLoading] = useState(false);

  function generateUniqueAlphabetId(length = 22) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }

    return result;
}

  const navigate = useNavigate();
  let ext_ref = q.get("ext_ref") || generateUniqueAlphabetId();

  const [headersNumber,setHeadersNumber] = useState('');

  // const title = document.getElementsByTagName("title")[0];
  // title.innerHTML = serviceName;

  const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' })

  const options = [
    { value: 'daily', label: 'Tous les jours/100 FCFA' },
    { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
    { value: 'monthly', label: 'Mensuelle/500 FCFA' },
  ];

  console.log(selectedOption)
  // const ExtId = Cookies.get('extId');

  const urlParams = new URLSearchParams(window.location.search);
  const msisdn = urlParams.get('msisdn');
  var ExtId = urlParams.get('extId');


  // Cookies.set('extId',ExtId);
    // Cookies.set('extId', ExtId, { expires: 6/24 });







  const checkUser = async () => {
  const num = Cookies.get('number');

  if (!num) return;

  try {
    const res = await axios.get(
      `${base_url_toonflix}/api/v1/check-status?msisdn=${num}&serviceName=MadFunny`
    );

    const statusCode = res.data?.statusCode;
    const msg = res.data?.message;

    if (statusCode === 200) {
      toast.success(msg || 'Abonnement actif');
      navigate('/redirect');
    }

  } catch (err) {
    console.log(err);

    const status = err?.response?.status;
    const msg = err?.response?.data?.message;

    if (status === 400) {
      toast.error(msg || 'Requête invalide, veuillez réessayer.');
      navigate('/subscribe');
    }

    if (status === 500) {
      toast.error(msg || 'Erreur serveur, veuillez réessayer plus tard.');
      navigate('/subscribe');
    }
  }
};

useEffect(() => {
  checkUser();
}, []);


  const handle = async (e) => {
  e.preventDefault();
  setLoading(true)

  try {

    //  Cookies.set('number', number, { expires: 6/24 })
    // Cookies.set('pack', selectedOption.value, { expires: 6/24 })

    if (!number) {
      toast.warn('Please Enter Number First!!')
      setLoading(false);
      return;
    }

    const res = await axios.post(`${base_url_toonflix}/api/v1/send`, {
      msisdn: number,
      serviceName: "MadFunny",
    });

    console.log(res.data);

    if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {
      toast.success(res.data?.message || 'Otp Sent Successfully!!')
        Cookies.set('number', number, { expires: 6/24 })
    Cookies.set('pack', selectedOption.value, { expires: 6/24 })
        Cookies.set('extId', ExtId, { expires: 6/24 });

      setTimeout(() => {
        navigate(`/otp-validation?id=${res.data?.data?.id ?? ''}`)
      }, 1000)
    } else {
      toast.error(res.data?.message || "Une erreur s'est produite");
    }

  }
  catch (err) {
    console.log(err)

    const status = err?.response?.status;
    const msg = err?.response?.data?.message;

    if (status === 400) {
      toast.error(msg || "Requête invalide, veuillez réessayer.");
    } else if (status === 500) {
      toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
    } else {
      toast.error(msg || "Une erreur s'est produite");
    }
  }

  setLoading(false)
}


  return (
    <div className='login-container' style={{ fontFamily: "'DM Sans', sans-serif" }}   >
{/* <ToastContainer/> */}

      <div className='w-full h-screen flex justify-center items-center' style={{ backdropFilter: 'blur(10px)',}}>
        <form onSubmit={handle} className=' max-w-lg rounded-md' style={{
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.2)', // Set a transparent white background
          backdropFilter: 'blur(10px)',
          border:'1px solid grey',
          padding: '20px',
        }}>
          <h1 className='text-white  text-2xl  md:text-4xl  mt-5'>Bienvenue à
            {serviceName === 'Mc Funny' ? <>
              <span className='font-bold px-2'>
                Mc Funny
              </span>
            </> : <span className='font-bold px-2'>
              Mad Funny
            </span>}
          </h1>
          <p className="text-end text-md font-bold ml-24 text-white" >-Service fourni par Panz</p>
 
          <p className='text-white text-sm mt-1 font-medium '>
          MadFunny est un portail de mèmes proposant des mèmes amusants et du contenu viral pour un divertissement et des rires quotidiens.

          </p>
          <h1 className='mt-4 text-white text-md font-bold'>{headersNumber == ''?'Entrez votre numéro':'Votre numéro'}</h1>
          <input type="text" class="bg-gray-50 focus:outline-none text-gray-900 mt-2 text-sm py-3 block w-full p-2.5  dark:border-gray-600  dark:gray-900"

            placeholder='Entrez votre numéro de téléphone : eg 812xxxxxx'
            id="phoneInput"
            name="ani"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            required />
          <div class="flex items-center mb-4 mt-3">
            <input id="default-checkbox" type="checkbox" value="" class="w-4 h-4 text-blue-600 bg-gray-100 focus:outline-none border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            <label for="default-checkbox" class="ml-2 text-md font-medium text-white dark:text-gray-300">J'ai accepté les conditions générales</label>
          </div>
          <p className='text-white pt-2 text-lg font-semibold'>Type de paquet</p>
          <Select
        defaultValue={selectedOption}
        onChange={setSelectedOption}
        options={options}
      />

          <button
            disabled={loading}
            type="submit"
            class="text-white w-full mt-2 bg-[#0D6EFD] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-7 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
            {loading ? "Chargement..." : "S'abonner"}
          </button>
          <p 
  onClick={() => navigate('/tnc')} 
  className="text-black font-bold text-center mt-4 underline cursor-pointer"
>
  Conditions générales
</p>
 <span className='text-xs font-semibold w-full text-center' >• Désinscription gratuite à tout moment : composez #303#10#.</span>
 <br></br>
        <span className='text-xs font-semibold w-full text-center' >• Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>

        </form>
        
      </div>
     
    </div>

  );
};

export default Login;
